var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isTaskOperate ? _c('div', [_c('operateTop', {
    attrs: {
      "visible-operate": _vm.value
    },
    on: {
      "showOpreate": _vm.showOpreate
    }
  }), _c('operateRed', {
    on: {
      "showOpreate": _vm.showOpreate
    }
  }), _vm.showDiaglog ? _c('taskDialog', {
    attrs: {
      "bg": "https://map-mobile-resource.cdn.bcebos.com/icon/service/yunying/default/yasuo113.png",
      "bg-width": 268,
      "bg-height": 353
    },
    on: {
      "close-task-dialog": _vm.closeTaskDialog,
      "click-content": _vm.closeTaskDialog
    }
  }) : _vm._e()], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };